// extracted by mini-css-extract-plugin
module.exports = {"textAreaWrapper":"TextArea_textAreaWrapper__9v6Zd","textAreaLabel":"TextArea_textAreaLabel__BXEoq"};